module.exports = __webpack_public_path__ + "static/img/IMG_20150610_214645.a361b1c6.jpg";